<template>
  <div class="userorgDialog">
    <sw-dialog
      width="680px"
      title="添加人员"
      :visible.sync="dialogVisible"
      @close="closeDialog"
    >
      <div>
        <div class="transfer-body">
          <div class="tb-left">
            <div class="tbl-head">可选列表</div>
            <div class="tbl-content">
              <div class="tblc-head">
                <sw-input
                  style="flex: 1; margin-right: 12px"
                  placeholder="搜索学工号/姓名"
                  prefix-icon="el-icon-search"
                  clearable
                  v-model="searchValue"
                >
                </sw-input>
                <div class="org_icon user_icon"></div>
              </div>
              <div class="tblc-content">
                <div v-show="!isSearch" style="min-height: 300px">
                  <OrgList
                    ref="orgList"
                    @change="handleChange"
                    :orgList="remoteOrganization"
                    :widget="widget"
                    @sendCurOrgId="getId"
                  />
                </div>
                <div
                  v-show="isSearch"
                  style="min-height: 300px"
                  v-loading="searchLoading"
                >
                  <List :list="searchGroupList" @change="handleChange" />
                </div>
              </div>
            </div>
          </div>
          <div class="tb-right">
            <div class="tbl-head">
              <span> 已选{{ selectedList.length }}人 </span>
              <el-button type="text" style="padding: 0" @click="handleClearAll"
                >清除</el-button
              >
            </div>
            <div class="tbr-content">
              <div class="tblc-head">
                <sw-input
                  style="flex: 1"
                  placeholder="搜索学工号/姓名"
                  prefix-icon="el-icon-search"
                  clearable
                  v-model="searchSelectedValue"
                >
                </sw-input>
              </div>
              <div class="tblc-content">
                <div class="selected-list">
                  <div
                    class="selected-item"
                    v-for="item in filterSelectedList"
                    :key="item.id"
                  >
                    <div
                      class="selected-item_content"
                      :title="
                        item.accountName +
                        '(' +
                        item.name +
                        ')-' +
                        item.organizationName
                      "
                    >
                      {{ item.accountName }}({{ item.name }})-{{
                        item.organizationName
                      }}
                    </div>
                    <div
                      class="selected-item_delete"
                      @click="handleChange(item)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <sw-button round @click="commitDialogCancel">取 消</sw-button>
        <sw-button round type="primary" @click="commitDialogConfirm"
          >确 定</sw-button
        >
      </div>
    </sw-dialog>
  </div>
</template>

<script>
import List from './list.vue'
import OrgList from './orgList.vue'
// import { getOrganizationMember } from '@/components/api/userOrgApi.js'
import { getPersonnelSelectionList } from '@/components/api/userOrgApi.js'

import alertUtils from '@/util/alertUtils.js'
import { debounce } from '@/util/index'
export default {
  components: {
    List,
    OrgList,
  },
  name: 'userorg-dialog',
  props: [
    'orgDialogVisible',
    'multiple',
    'remoteOrganization',
    'optionsList',
    'searchGroupData',
    'widget',
  ],
  data() {
    return {
      dialogVisible: this.orgDialogVisible,
      isMulti: this.multiple,
      searchValue: '',
      pageIndex: '0',
      pageSize: '50',
      searchSelectedValue: '',
      // selectedList: [],
      selectedList: this.optionsList,
      isSearch: false,
      searchLoading: false,
      searchGroupList: [],
      orgId: '',
    }
  },
  created() {
    this.$watch(
      'searchValue',
      debounce(newValue => {
        if (newValue.trim()) {
          this.isSearch = true
          this.getFuzzySearch()
        } else {
          this.isSearch = false
        }
      }, 500)
    )
  },
  computed: {
    filterSelectedList() {
      if (!this.searchSelectedValue) {
        return this.selectedList
      }
      const list = this.selectedList.filter(item => {
        return (
          item.accountName.indexOf(this.searchSelectedValue) > -1 ||
          item.name.indexOf(this.searchSelectedValue) > -1
        )
      })
      return list
    },
  },
  methods: {
    closeDialog() {
      this.$emit('update:orgDialogVisible', false)
    },
    handleClearAll() {
      this.selectedList = []
      this.$refs.orgList.allCheck = false
    },
    handleChange(item) {
      if (this.isMulti) {
        // 多选
        this.handleMultiChange(item)
      } else {
        // 单选
        this.handleSingleChange(item)
      }
    },
    handleMultiChange(item) {
      if (item.checked) {
        // 如果是已经勾选的，点击进行取消勾选，从已选中删除
        item.checked = false
        this.sliceSelected(item)
      } else {
        // 未勾选的，点击进行勾选，加入已选
        item.checked = true
        this.pushSelected(item)
      }
    },
    sliceSelected(item) {
      this.deletArrItemFunc(this.selectedList, item.id)
    },
    deletArrItemFunc(list, deleteID) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === deleteID) {
          list.splice(i, 1)
        }
      }
    },
    pushSelected(item) {
      if (this.selectedList.findIndex(sItem => sItem.id === item.id) === -1) {
        this.selectedList.push(item)
      }
    },
    handleSingleChange(item) {
      if (item.checked) {
        // 如果是已经勾选的，点击进行取消勾选，从已选中删除
        item.checked = false
        this.selectedList = []
        return
      }
      // 未勾选的，点击进行勾选，加入已选
      item.checked = true
      this.selectedList = [item]
    },
    // 刷新列表选中状态
    refreshListChecked(list, userList) {
      const temp = JSON.parse(JSON.stringify(userList))
      const checkedAccountList = list.map(item => {
        return item.id
      })
      for (let i = 0; i < temp.length; i++) {
        const user = temp[i]
        if (checkedAccountList.includes(user.id)) {
          user.checked = true
        } else {
          user.checked = false
        }
        this.$set(userList, 'i', user)
      }
      return temp
    },
    getId(val) {
      this.orgId = val
    },
    async getFuzzySearch() {
      //
      this.searchLoading = true
      let params = {
        // organizationId:
        //   this.orgId === 'qb' || this.orgId === ''
        //     ? this.remoteOrganization[0].id
        //     : this.orgId,
        // pageIndex: this.pageIndex,
        // pageSize: this.pageSize,
        // keyWord: this.searchValue,
        // fetchSub: true, // 是否查询子组织机构人员

        orgId:
          this.orgId === 'qb' || this.orgId === ''
            ? this.remoteOrganization[0].id
            : this.orgId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        keyWord: this.searchValue,
        fetchSub: true, // 是否查询子组织机构人员
        identityTypeIds: this.widget.options.identityTypeIds,
      }
      if (this.widget.options.groupId) {
        params.type = 'group'
        params.groupId = this.widget.options.groupId
      }
      if (this.widget.options.useOraganization) {
        params.type = 'org'
      }
      if (this.widget.options.groupId && this.widget.options.useOraganization) {
        params.type = 'orgAndGroup'
        params.groupId = this.widget.options.groupId
      }
      try {
        // const res = await getOrganizationMember(params)
        const res = await getPersonnelSelectionList(params)
        this.searchLoading = false
        if (res.flag) {
          this.searchGroupList = res.data.map(item => {
            item.checked = false
            return item
          })
          this.searchGroupList = this.refreshListChecked(
            this.selectedList,
            this.searchGroupList
          )
        }
      } catch (error) {
        alertUtils.alertError(error)
      }
    },
    commitDialogCancel() {
      this.$emit('update:orgDialogVisible', false)
    },
    commitDialogConfirm() {
      this.$emit('sendList', this.selectedList)
      this.$parent.changeValue()
      this.$emit('update:orgDialogVisible', false)
    },
  },
  watch: {
    orgDialogVisible: {
      handler(val) {
        this.dialogVisible = val
        if (val) {
          this.selectedList = JSON.parse(JSON.stringify(this.optionsList))
        }
      },
      immediate: true,
    },
    selectedList(newVal) {
      // VUE_TIP: 注意：在变更 (不是替换) 对象或数组时，旧值将与新值相同，因为它们的引用指向同一个对象/数组。Vue 不会保留变更之前值的副本。
      // 监听到已选列表，刷新orgUserList的选中状态
      if (this.$refs.orgList) {
        this.$refs.orgList.orgUserList = this.refreshListChecked(
          newVal,
          this.$refs.orgList.orgUserList
        )
      }
      this.searchGroupList = this.refreshListChecked(
        newVal,
        this.searchGroupList
      )
    },
  },
}
</script>

<style lang="scss" scoped>
div::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
div::-webkit-scrollbar-thumb {
  background: #ccc;
}
.transfer-body {
  display: flex;
  width: 100%;
  min-height: 467px;
  font-size: 14px;
  color: rgba(2, 21, 37, 0.85);
  padding-top: 5px;
}
.tb-left,
.tb-right {
  flex: 1;
  overflow: hidden;
  border-radius: 1px;
  border: 1px solid #e6ecf2;
}
.tb-left {
  margin-right: 20px;
  box-shadow: 0px 2px 8px 0px rgba(2, 21, 37, 0.12);
}
.tbl-head {
  padding: 9px 12px;
  font-size: 14px;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: #021525;
  line-height: 22px;
  border-bottom: 1px solid #e6ecf2;
}
.tbl-content {
  padding: 12px;
  width: 100%;
}

.org_icon {
  width: 20px;
  height: 20px;
  background: url('~@/assets/zuzhi-3.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // cursor: pointer;
  // transition: all 0.3s;
  // &:hover {
  //   transform: scale(1.2);
  //   transition: all 0.3s;
  // }
}
.user_icon {
  background: url('~@/assets/renyuan.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.tblc-head {
  display: flex;
  align-items: center;
}

.tblc-content {
  margin-top: 18px;
  width: 100%;
  height: 400px;
  overflow-y: auto;
}
.tbr-content {
  .tblc-head {
    padding: 12px;
  }
  .tblc-content {
    margin-top: 0;
  }
}
.tb-right .tbl-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.selected-item {
  margin-top: 2px;
  padding: 5px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-family:
    PingFangSC-Regular,
    PingFang SC;
  font-weight: 400;
  color: rgba(2, 21, 37, 0.85);
  line-height: 22px;
  background: #f4f8fc;
}
.selected-item_delete {
  cursor: pointer;
  width: 16px;
  height: 16px;
  background: url('~@/assets/icon-clear.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.selected-item_content {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .sw-dialog.el-dialog {
  border-radius: 8px;
  .el-dialog__body {
    padding: 20px 30px;
  }
  .el-dialog__header {
    border-radius: 8px 8px 0px 0px;
  }
  .el-dialog__footer {
    border-radius: 0px 0px 8px 8px;
  }
}
</style>
